<template>
  <div class="col-md-12">
    <div class="x_panel">
      <div class="x_title">
        <h4>綜合資料</h4>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h5 class="col-md-4">訂單種類:</h5>
          <h5 class="col-md-8">{{ transaction.taxi_sort }}</h5>
        </div>
        <div class="col-md-6">
          <h5 class="col-md-4">派車單狀態:</h5>
          <h5 class="col-md-8">{{ statusStr }}</h5>
          <el-button
            type="danger"
            @click="$emit('onException')"
            v-show="transaction.result === '異常'"
          >
            異常處理
          </el-button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h5 class="col-md-4">所需的車輛數:</h5>
          <h5 class="col-md-8">1輛</h5>
        </div>
        <div class="col-md-6">
          <h5 class="col-md-4">派遣種類:</h5>
          <h5 class="col-md-8">{{ transaction.assign_sort }}</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h5 class="col-md-4">排班站:</h5>
          <h5 class="col-md-8">{{ transaction.scheduled_station }}</h5>
        </div>
        <div class="col-md-6">
          <h5 class="col-md-4">派遣策略:</h5>
          <h5 class="col-md-8">{{ transaction.strategy_name }}</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <h5 class="col-md-4">取消客服:</h5>
          <h5 class="col-md-8">{{ cancelServiceName }}</h5>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10">
          <h5 class="col-md-3">取消原因:</h5>
          <h5 class="col-md-8">{{ cancelReason }}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    transaction: Object,
  },
  computed: {
    statusStr() {
      if (this.transaction.passenger_cancel || this.transaction.driver_cancel) {
        return '已取消'
      }
      return this.transaction.result
    },
    cancelReason() {
      if (this.statusStr && this.transaction.finish_time) {
        if (this.statusStr.includes('已取消')) {
          let cancelReason = ''
          if (this.transaction.driver_cancel) {
            cancelReason = this.transaction.driver_cancel
          } else {
            if (this.transaction.passenger_cancel.includes(',')) {
              cancelReason =
                this.transaction.passenger_cancel.split(',')[2] === ''
                  ? this.transaction.result
                  : this.transaction.passenger_cancel.split(',')[0]
            } else {
              cancelReason = this.transaction.passenger_cancel
            }
          }
          return `${cancelReason} ${this.transaction.finish_time}`
        }
      }
      return ''
    },
    cancelServiceName() {
      // 若statusStr為已取消，代表此訂單是取消的訂單
      if (this.statusStr && this.transaction.call_method) {
        if (this.statusStr === '已取消' && this.transaction.passenger_cancel) {
          const serviceName = this.transaction.passenger_cancel.split(',')[2]
          if (serviceName) {
            return serviceName
          }
        }
      }
      return ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/transaction/components/Combine.vue